import React from "react";
import moment from "moment";
import l from "components/util/l";


const VersionListView = ({ flows, placeholder, onClickRestoreVersion }) => (
  <div id="versions-list">

    <div className="row row-cols-1">
      {flows.map((flow) => (
        <div key={flow.id} className="list-group">
          <div className="list-group-item my-1">
            <div className="media">

              <div className="media-body">
                <div className="row align-items-sm-center">
                  <div className="col">
                    <h5 className="mb-0">
                      {flow.isReleaseVersion == true && <><span className="badge badge-primary mb-1">{l("Versión de lanzamiento%SA174")}</span><br/></>}
                      {flow?.versionSettings?.title ?? <>{l("Versión del%SA173")} {moment(flow.versionDate).format("DD-MM-YYYY")}</>}
                    </h5>
                    <span style={{ fontSize: "0.94em" }}>{flow?.versionSettings?.description ?? moment(flow.versionDate).format("HH:mm")}</span>
                  </div>

                  <div className="col-auto">
                    <button className="btn btn-sm btn-outline-primary" onClick={() => onClickRestoreVersion(flow.id)}>
                      <i className="fas fa-trash-restore mr-1"></i> {l("Restaurar%SA175")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

    {flows.length == 0 && (
      <div className="h-100" style={{
        color: "#b0b2b2",
        fontSize: "0.95em"
      }}>
        <div className="d-flex justify-content-start align-items-center h-100 ml-1">
          <span>{placeholder}</span>
        </div>
      </div>
    )}

  </div>
);


export default VersionListView;